module.exports = __webpack_public_path__ + "static/slide-tag-cloud-e257ee6d6bd7cb84255a551840275178.png";